import { getChatAttachmentName } from "web_myplann/Chat/Helpers/Attachments/getChatAttachmentName";
import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";
import type { ChatMessageResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const mapChatMessage = (
	dto: ChatMessageResponseDTO,
): ChatMessageView => ({
	id: dto.id,
	content: dto.content,
	direction: dto.isMine ? "sender" : "recipient",
	isRead: dto.isRead,
	createdAt: new Date(dto.createdAt),
	fromName: dto.fromName,
	attachments: dto.attachments.map((attachment) => ({
		id: attachment.id,
		mimeType: attachment.mimeType,
		fileName: getChatAttachmentName(
			attachment.fileName,
			attachment.mimeType,
			attachment.id,
		),
		isImage: attachment.type === "image",
	})),
});
